import React from 'react'
import Navbar from '../inc/Navbar'

import {Link } from "react-router-dom";
import About from './About'
function Aboutpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        
        <div className='color'>
          <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"> Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/Contact" >Contact  Us</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">About Us</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                </div>
                <br/>
        <About/>
        <br/>
    </div>
  )
}

export default Aboutpage